import { Center, Container, Flex, Image, VStack } from '@chakra-ui/react';
import React from 'react';
import './Home.css';

const WhatIDo = () => {
    return (
        <Container maxW="container.lg" my={20} className='rounded-lg'>
            <Flex direction={["column-reverse", "column-reverse", "row-reverse"]} className='rounded-lg dark:shadow-gray-700 dark:bg-gray-800'>
                <Center className="flex-1 shadow hover:shadow-lg order-2 rounded-lg">
                    <VStack p="4" alignItems={["center", "center", "start"]}>
                        {/*  */}
                        <div id="" className='w-auto'>
                            <div id="" className=''>
                                <div className="max-w-md py-4 px-8 hover:bg-blue-300 dark:bg-lime-300 shadow-lg rounded-lg my-20">
                                    <div className="flex justify-center md:justify-end -mt-16">
                                        <img className="w-15 h-20 object-fill rounded " src={"https://i.ibb.co/tCcKFhr/me-dark.png"}/>
                                    </div>
                                    <div className=''>
                                        <h2 className="text-gray-800 text-3xl font-bold font-mono border-b-2 pb-1 border-gray-800  ">What I Do</h2>
                                        <p className="mt-2 text-gray-600 text-base font-bold font-mono card_title pt-1">I am a Full-Stack (MERN) also WordPress Web Designer & Developer. A lot of experience in Data Analysis & Branding, promoting business, showcasing other works, bug-fix, e-commerce solutions, blog-sites etc.</p>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        {/*  */}

                    </VStack>
                </Center>
                <Center
                    w={["auto", "auto", 350, 400]}
                    className="shadow order-1 hover:shadow-lg  rounded-lg p-2"
                >
                    <Image className="w-auto " fit={"cover"} src={"https://i.ibb.co/0s3Bww4/herobg.png"} align="top"></Image>
                </Center>
            </Flex>
        </Container>
    );
};



export default WhatIDo;

